export enum CertificateType {
  Certificate = 1,
  Procuration = 2,
  Others = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/CertificateType.ts